import React, { useState } from 'react';
import styles from './index.module.css';
import { OrderType } from 'models/order.model';
import NoRiderIcon from '../../assets/images/no-rider-yet.png';
import AssignRiderModal from 'components/live-trip-cards/live-trip-modals/assign-rider-modal';
import { isCSRole } from 'utils/functions';

const NoRider = ({ order, isComplete }: { order: OrderType; isComplete?: boolean }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className={`pb-5  bg-white  relative `}>
      <div
        className={`bg-white ${styles['section-header-2']} py-[18px] flex-col gap-2 sm:flex-row sm:justify-between rounded-[6px]`}>
        <div className='flex justify-end items-center w-full'>
          {!isComplete && !isCSRole() && (
            <button
              className='text-sm w-fit font-medium text-[#E60A2B]'
              onClick={() => setShowModal(true)}>
              Assign rider
            </button>
          )}
        </div>
      </div>

      <div className='center'>
        <div>
          <img src={NoRiderIcon} alt='pickup order' width={180} height={180} className='mt-2' />
          <div className='text-center text-gray-5 mt-[-28px]'>No rider yet</div>
        </div>
      </div>
      <AssignRiderModal order={order} show={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};
export default NoRider;
